import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="pt-28 pb-20 bg-amber-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="section-title mb-10">Privacy Policy</h1>

        <div className="space-y-6 text-amber-800 leading-relaxed">
          <p>
            BSM Bhojan Seva Mandal Foundation respects your privacy and is committed
            to protecting your personal information.
          </p>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Information We Collect
            </h2>
            <p>
              We may collect your name, phone number, email address, and payment
              details when you contact us or while making a membership payment through our website.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              How We Use Information
            </h2>
            <p>
              Your information is used solely for communication, membership fee processing, receipts, legal compliance, and improving our services.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Payment Security
            </h2>
            <p>
              {/* All online payments are securely processed through trusted
              third-party payment gateways. We do not store your banking or card
              information on our servers. */}
              All online membership payments will be securely processed through trusted
              third-party payment gateway Razorpay. We do not store your banking or card
              information on our servers.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Data Protection
            </h2>
            <p>
              We do not sell, rent, or share your personal information with
              third parties except where required by law.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Contact
            </h2>
            <p>
              For any privacy-related concerns, please contact us through our
              Contact Us page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}